<template>
  <Logs />
</template>

<script>
import Logs from '@/components/admin/logs/StudentsHistory.vue'

export default {
  name: 'AdministrationStudentsLogs',
  components: { Logs }
}
</script>

<style scoped>

</style>
